import { useState, useEffect } from "react";
import { API } from "../api";

// Component that loads an authenticated image using the Bearer token
// Muestra imÃ¡genes de evidencia â€” ahora con URL directo de Cloudinary
const AuthImage = ({ fileId, fileUrl, filename, token, className }) => {
  const [error, setError] = useState(false);
  const [resolvedUrl, setResolvedUrl] = useState(fileUrl || null);

  useEffect(() => {
    // Si ya tenemos URL de Cloudinary, Ãºsala directo
    if (fileUrl) { setResolvedUrl(fileUrl); return; }
    // Fallback para archivos legacy en MongoDB (base64)
    if (!fileId || !token) return;
    let url = null;
    fetch(`${API}/files/${fileId}`, { headers: { 'Authorization': `Bearer ${token}` } })
      .then(res => { if (!res.ok) throw new Error('no access'); return res.blob(); })
      .then(blob => { url = URL.createObjectURL(blob); setResolvedUrl(url); })
      .catch(() => setError(true));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [fileId, fileUrl, token]);

  if (error) return <div className="w-40 h-40 bg-gray-100 rounded-lg flex items-center justify-center text-xs text-gray-400">No disponible</div>;
  if (!resolvedUrl) return <div className="w-40 h-40 bg-gray-100 rounded-lg animate-pulse"></div>;
  return (
    <a href={resolvedUrl} target="_blank" rel="noopener noreferrer" className="block">
      <img src={resolvedUrl} alt={filename} className={className} onError={() => setError(true)} />
      <p className="text-xs text-gray-500 mt-1 text-center truncate w-40">{filename}</p>
    </a>
  );
};

// Descarga archivos de evidencia â€” ahora con URL directo de Cloudinary
const AuthFileLink = ({ fileId, fileUrl, filename, token }) => {
  const handleDownload = async (e) => {
    e.preventDefault();
    // Si tenemos URL de Cloudinary, abre directo en nueva pestaÃ±a
    if (fileUrl) { window.open(fileUrl, '_blank'); return; }
    // Fallback legacy
    try {
      const res = await fetch(`${API}/files/${fileId}`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (!res.ok) throw new Error('no access');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = filename;
      document.body.appendChild(a); a.click();
      document.body.removeChild(a); URL.revokeObjectURL(url);
    } catch { alert('No se pudo descargar el archivo.'); }
  };
  return (
    <button onClick={handleDownload}
      className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-lg px-4 py-3 text-sm text-blue-600 hover:bg-gray-100 transition-colors shadow-sm">
      <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
      <span className="truncate max-w-xs">{filename}</span>
    </button>
  );
};

export { AuthImage, AuthFileLink };
